import React from 'react';
import ContributionBox from '../ContributionBox';
import { useContribution } from '../../hooks/useContribution';
import { useUserStats } from '../../hooks/useUserStats';
import { useWallet } from '@solana/wallet-adapter-react';

/**
 * Contribution Section component
 * Handles user contribution UI and interactions
 */
const ContributionSection = () => {
  const { 
    amount, 
    handleAmountChange, 
    handlePresetContribution, 
    handleContributionTypeSelect,
    handleClaim,
    handleAllDaysContribution
  } = useContribution();
  
  const { userStats } = useUserStats();
  const wallet = useWallet();
  
  return (
    <ContributionBox
      amount={amount}
      handleAmountChange={handleAmountChange}
      handlePresetContribution={handlePresetContribution}
      handleContributionTypeSelect={handleContributionTypeSelect}
      handleClaim={handleClaim}
      handleAllDaysContribution={handleAllDaysContribution}
      isWalletConnected={wallet.connected}
      hasTotalContribution={userStats.totalContribution > 0}
    />
  );
};

export default ContributionSection;
